import {
  Radio as RadioMui,
  type RadioProps as MuiRadioProps,
} from '@mui/material';
import type { SxProps, Theme } from '@mui/material/styles';

interface RadioProps extends Omit<MuiRadioProps, 'sx'> {
  sx?: SxProps<Theme>;
}

const Radio = ({ sx: sxRadio = {}, ...props }: RadioProps) => {
  return <RadioMui sx={sxRadio} {...props} />;
};

export default Radio;
export type { RadioProps };
